<script setup lang="ts">
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import { formatDateTime } from '@/services/functions';
import i18n from '@/lang/i18n';

const props = defineProps<{
  deliveryPlan?: getDeliveryPlanVehicleInformation;
}>();

function changeFormat(dateTime: string | null) {
  return dateTime ? formatDateTime(new Date(dateTime)) : '';
}
</script>
<template>
  <v-col cols="12">
    <div class="mb-1">
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.splitForm.tripId') }}
      </span>
      {{ props.deliveryPlan?.delivery_plan_id }}
    </div>
    <div class="mb-1">
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.splitForm.carNumber') }}
      </span>
      {{ props.deliveryPlan?.car_number }}
    </div>
    <div class="mb-1">
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.splitForm.driver') }}
      </span>
      {{ props.deliveryPlan?.driver?.full_name }}
    </div>
    <div class="mb-1">
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.alterLeavingOrReturning.leavingDateTime') }}
      </span>
      {{ changeFormat(props.deliveryPlan?.leaving_warehouse_date_time ?? null) }}
    </div>
    <div>
      <span class="font-weight-bold">
        {{ i18n.global.t('pages.dailyReports.alterLeavingOrReturning.returningDateTime') }}
      </span>
      {{ changeFormat(props.deliveryPlan?.returning_warehouse_date_time ?? null) }}
    </div>
  </v-col>
</template>
